import { measureViewportBox as s } from "./atoms-v21186.js";
import { DOMVisualElement as n } from "./atoms-v21187.js";
import { isCSSVariableName as a } from "./atoms-v21083.js";
import { getDefaultValueType as u } from "./atoms-v21103.js";
import { buildHTMLStyles as p } from "./atoms-v21188.js";
import { transformProps as i } from "./atoms-v2932.js";
import { renderHTML as l } from "./atoms-v21189.js";
import { scrapeMotionValuesFromProps as f } from "./atoms-v21190.js";
function c(m) {
  return window.getComputedStyle(m);
}
class w extends n {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = l;
  }
  readValueFromInstance(t, e) {
    if (i.has(e)) {
      const r = u(e);
      return r && r.default || 0;
    } else {
      const r = c(t), o = (a(e) ? r.getPropertyValue(e) : r[e]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: e }) {
    return s(t, e);
  }
  build(t, e, r) {
    p(t, e, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, e, r) {
    return f(t, e, r);
  }
}
export {
  w as HTMLVisualElement,
  c as getComputedStyle
};
